"use strict";
/**
 * **Colaborador ↔ fichas de QVET: el enlace, y lo que falta por decidir.** GH527 · SP8 §3.5.
 *
 * `GET /api/qvet/staff-mapping/links` · `PATCH /api/qvet/staff-mapping/links/:colCode`
 *
 * The collaborator is a **class-D** entity, not class C: QVET's staff ficha stays where it is
 * and we keep the keys — `qvetStaffIds`. So there is no `qvetSync`, no `hvpData` and nothing to
 * propose. What there is instead is a decision only a person can take.
 *
 * ## Why a screen, and not a script
 *
 * Measured in production on 2026-09-11, over **80 aliases across 43 collaborators**: 58 match
 * exactly one QVET ficha, 17 carry the `DUP<id> -` prefix QVET puts on duplicates — **and 11 do
 * not resolve**. Six match several fichas and five match none. One of the five is «NESTOR JOSE
 * DELGADO CARREO»: **CARREÑO without the Ñ**, and not a normalisation bug — the letter was never
 * typed.
 *
 * 🚨 **Those 11 must not be guessed.** Picking the wrong ficha credits one person with another's
 * sales, and the mistake is invisible afterwards. So they are surfaced, with their candidates,
 * and a human chooses.
 *
 * ## And why the typed names stay
 *
 * `qvetAliases` is not replaced by `qvetStaffIds`; the two live together. **QVET's reports carry
 * no staff id** — `sellerName`, `collectorName`, `staffName`, `userName`, all text — so telling
 * whose a 2022 sale was still means matching by the name **of that day**. The ids are the stable
 * link; the names are the history, and deleting one would leave old sales with no owner.
 */
Object.defineProperty(exports, "__esModule", { value: true });
